import { render, staticRenderFns } from "./Deposite.vue?vue&type=template&id=21613c77&scoped=true&"
import script from "./Deposite.vue?vue&type=script&lang=js&"
export * from "./Deposite.vue?vue&type=script&lang=js&"
import style0 from "./Deposite.vue?vue&type=style&index=0&id=21613c77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21613c77",
  null
  
)

export default component.exports